module.exports = __webpack_public_path__ + "static/media/logo-kiuono.7a4b5423.svg";